module.exports = __webpack_public_path__ + "static/media/07_plantilla_combo_rectangular_fondo_3.7d0408d8.jpg";